import React from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from '../../utils/animations';

const FundraiserContest = () => {
  return (
    <div className="flex flex-col items-center w-full max-w-2xl mx-auto px-8">
      {/* Challenge Title */}
      <h2 className="text-[#805AD5] text-xl text-center mb-6">
        RAPS-4-SNACKS Challenge
      </h2>

      {/* How to Enter */}
      <div className="bg-[#1A1A1A] rounded-lg p-6 mb-8 w-full">
        <h3 className="text-[#805AD5] text-sm mb-2">Contest Rules</h3>
        <ul className="space-y-2 text-gray-300 text-sm">
          <li>Submit a 16-32 bar verse about hunger (metaphorical or literal)</li>
          <li>Post your video on Instagram</li>
          <li>Tag @sonny.souf</li>
          <li>Use hashtag #RAPS4SNACKS</li>
          <li>Share the fundraiser link</li>
        </ul>
      </div>

      {/* Prize & Timeline */}
      <div className="bg-[#1A1A1A] rounded-lg p-6 mb-8 w-full">
        <h3 className="text-[#805AD5] text-sm mb-2">Grand Prize</h3>
        <p className="text-gray-300 text-sm mb-6">$100 for the "Most Hungry Verse" + Feature Repost</p>
        
        <h3 className="text-[#805AD5] text-sm mb-2">Timeline</h3>
        <ul className="text-gray-300 text-sm">
          <li>Submission Deadline: January 10th</li>
          <li>Fan Voting: January 11th - 31st</li>
          <li>Winner Announced: January 31st</li>
        </ul>
      </div>

      {/* Impact */}
      <div className="bg-[#1A1A1A] rounded-lg p-6 mb-12 w-full">
        <h3 className="text-[#805AD5] text-sm mb-2">Fundraising Target</h3>
        <p className="text-gray-300 text-sm mb-4">
          Your support helps provide daily nutrition to students in need. Each donation goes directly 
          to purchasing PB&Js and apples for students.
        </p>
        <div className="text-gray-300 text-sm">
          <p>Weekly Cost: $30.12</p>
          <p>School Year Remainder: 20 weeks</p>
          <p className="font-bold">Total Goal: $602.40</p>
        </div>
      </div>

      {/* Call to Action */}
      <motion.div 
        variants={fadeIn}
        className="w-full flex flex-col items-center gap-6 mb-16"
      >
        <a
          href="https://www.gofundme.com/f/help-hungry-students-with-raps4snacks"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#805AD5] text-white px-12 py-3 rounded text-sm font-['Orbitron'] uppercase tracking-wider hover:bg-opacity-90 transition-all text-center w-full max-w-md"
        >
          DONATE NOW
          <span className="block text-xs mt-1">SUPPORT STUDENTS</span>
        </a>
      </motion.div>

      {/* Logos Section */}
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center items-center mb-16">
        <div className="w-48">
          <img 
            src="/rap4snacks.png" 
            alt="RAPS 4 SNACKS Logo" 
            className="w-full h-auto"
          />
        </div>
        {/* Additional sponsor logo placeholders */}
        <div className="w-48 h-48 bg-[#1A1A1A] rounded-lg opacity-30 hidden md:block"></div>
        <div className="w-48 h-48 bg-[#1A1A1A] rounded-lg opacity-30 hidden lg:block"></div>
      </div>
    </div>
  );
};

export default FundraiserContest;